import React, { Component } from 'react'
import { Button, Icon, Input, Popconfirm, Select, Form, Tooltip } from 'antd'
import { SendMessageRequest } from 'models/request/Index'
import { PushNotification } from 'utils/PushNotification'
import { sendMessage, getGroupsConfig } from 'services/CeberusApiService'

const FormItem = Form.Item
const { TextArea } = Input
const Option = Select.Option

export class MessagesConponent extends Component<any> {
  state = {
    isLoading: false,
    content: '',
    ticketId: null,
    isLoadingGroup: false,
    groupOptions: [],
    group: '',
    disableTicketId: true
  }

  async componentDidMount() {
    this.setState({ isLoadingGroup: true })

    try {
      let groups = await getGroupsConfig()

      this.setState({ groupOptions: groups })
    } catch (err) {
      PushNotification.error('Failed to load groups. Please try again.')
    } finally {
      this.setState({ isLoadingGroup: false })
    }
  }

  handleOnSendMessage = async (
    error: any,
    requestBody: SendMessageRequest
  ): Promise<void> => {
    const { form } = this.props

    try {
      requestBody.Content = requestBody.Content.trim().replace(/\\n/g, '\n')
      requestBody.Group = requestBody.Group.trim()

      const rawTicket = requestBody.TicketId
      const ticketNumber =
        rawTicket === null || rawTicket === undefined ? 0 : Number(rawTicket)
      requestBody.TicketId = this.state.disableTicketId ? 0 : ticketNumber

      if (requestBody.Content === undefined || requestBody.Content === '') {
        PushNotification.error('Message can not be undefined')
        return
      }
      if (requestBody.TicketId < 0) {
        PushNotification.error('Ticket ID must be not a negative number')
        return
      }

      await sendMessage(requestBody)
      PushNotification.success('Message sent successfully!')

      form.resetFields()
    } catch (httpError) {
      PushNotification.httpError(httpError)
    } finally {
      this.setState({ isLoading: false })
    }
  }

  handleSubmit = () => {
    const { form } = this.props

    this.setState({ isLoading: true })

    form.validateFields((error, values) => {
      if (error) {
        this.setState({ isLoading: false })
        return
      }
      this.handleOnSendMessage(null, values)
    })
  }

  handleGroupChange = (value: string) => {
    const group = this.state.groupOptions.find(
      (group: any) => group.GroupName === value
    )

    const allowToSendZendeskComment = group
      ? !!group.AllowToSendZendeskComment
      : false

    this.setState({
      groupName: value,
      disableTicketId: !allowToSendZendeskComment
    })

    if (!allowToSendZendeskComment)
      this.props.form.setFieldsValue({ TicketId: 0 })
  }

  render() {
    const { form } = this.props
    const { getFieldDecorator } = form

    return (
      <div className="flex flex-wrap">
        <div className="tc w-100">
          <Form layout="vertical">
            <FormItem label="Message">
              {getFieldDecorator('Content', {
                rules: [
                  { required: true, message: 'Please input your message!' }
                ]
              })(<TextArea rows={20} />)}
            </FormItem>

            <FormItem
              label={
                <span>
                  Ticket ID &nbsp;
                  <Tooltip title="Use 0 to avoid sending the message to any Zendesk ticket">
                    <Icon type="info-circle" style={{ color: '#1890ff' }} />
                  </Tooltip>
                </span>
              }
            >
              {getFieldDecorator('TicketId')(
                <Input type="number" disabled={this.state.disableTicketId} />
              )}
            </FormItem>

            <FormItem label="Group name">
              {getFieldDecorator('Group', {
                rules: [{ required: true, message: 'Please select a group!' }]
              })(
                <Select
                  getPopupContainer={trigger =>
                    trigger.parentNode as HTMLElement
                  }
                  placeholder="Select a group"
                  showSearch
                  optionFilterProp="children"
                  notFoundContent={
                    this.state.isLoadingGroup
                      ? 'loading...'
                      : 'Group`s not found'
                  }
                  onChange={this.handleGroupChange}
                >
                  {this.state.groupOptions.map((opt: any) => (
                    <Option key={opt.GroupName} value={opt.GroupName}>
                      <span
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          width: '100%'
                        }}
                      >
                        <span>{opt.GroupName}</span>
                        <Tooltip
                          title={
                            opt.AllowToSendZendeskComment
                              ? 'Zendesk habilitado'
                              : 'Zendesk desabilitado'
                          }
                        >
                          <Icon
                            type={
                              opt.AllowToSendZendeskComment
                                ? 'check-circle'
                                : 'close-circle'
                            }
                            style={{
                              marginLeft: 6,
                              color: opt.AllowToSendZendeskComment
                                ? 'green'
                                : 'red'
                            }}
                          />
                        </Tooltip>
                      </span>
                    </Option>
                  ))}
                </Select>
              )}
            </FormItem>

            <FormItem>
              <Popconfirm
                title="This action is IRREVERSIBLE. Are you sure?"
                onConfirm={this.handleSubmit}
              >
                <Button type="primary" loading={this.state.isLoading}>
                  <Icon type="message" /> Send message
                </Button>
              </Popconfirm>
            </FormItem>
          </Form>
        </div>
      </div>
    )
  }
}

export const SendMessage = Form.create({ name: 'organization-form' })(
  MessagesConponent
)
